<template>

  <fieldset class="groupedfield">

    <legend class="groupedfieldText label">
      {{label}}
    </legend>
    <br>
    <app-config-form :schemaBased="fieldSchema" ref="appConfigForm" />

  </fieldset>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScField,
  ScSelect,
} from "@intelipost-js/secure-components";

const { mapState, mapActions } = createNamespacedHelpers(
  "integrations/integrationsHome"
);

export default {
  name: "grouped-field",

  props: {
    fieldSchema: {
      type: Object
    },
  },

  data() {
    return {
      label: ''
    }
  },

  computed: {
    ...mapState(["appConfigUpdated"]),
  },

  methods: {

    ...mapActions([
      "updateAppConfig",
    ]),

    validate() {
      return this.$refs.appConfigForm.validate();
    },

  },

  mounted() {
    this.label = this.fieldSchema.title;
  },

  components:{
    ScField,
    ScSelect,
    'app-config-form': () => import('./AppConfigForm.vue')
  }
}
</script>
<style>
  .groupedfield {
    border: 1px solid lightgrey; 
    padding: 5px;
  }
  .groupedfieldText {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/modal/components/GroupedField.vue?7b8ef89d